import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from "@/libs/acl/ability";

export default function useReceiptDocumentDescriptionsList() {
  // Use toast
  const toast = useToast()

  const refReceiptDocumentDescriptionListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: "sort_order", label: "排序", sortable: true, class: "sticky-column"},
    { key: "actions", label: "操作", class: "sticky-column" },
    { key: "name", label: "標題", sortable: true },
    { key: "description", label: "內容", sortable: true, class: 'pre-wrap mw-300' },
    { key: "is_active", label: "狀態", sortable: true },
    { key: "updated_at", label: "修改日期", sortable: true },
    { key: "created_at", label: "創建日期", sortable: true },
  ]

  const perPage = ref(10)
  const totalReceiptDocumentDescriptions = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const isActiveFilter = ref(null)

  const receiptDocumentDescriptionsList = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refReceiptDocumentDescriptionListTable.value ? refReceiptDocumentDescriptionListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalReceiptDocumentDescriptions.value,
    }
  })

  const refetchData = () => {
    refReceiptDocumentDescriptionListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, isActiveFilter], () => {
    refetchData()
  })

  watch(sortBy, (val) => {
    refReceiptDocumentDescriptionListTable.value.refresh()
  })

  const fetchReceiptDocumentDescriptions = (ctx, callback) => {
    store
      .dispatch('receipt-document-description/fetchReceiptDocumentDescriptions', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        is_active: isActiveFilter.value,
      })
      .then(response => {
        const { receiptDocumentDescriptions, total } = response.data
        callback(receiptDocumentDescriptions)
        totalReceiptDocumentDescriptions.value = total
        receiptDocumentDescriptionsList.value = receiptDocumentDescriptions
      })
      .catch(err => {
        console.log(err)
        toast({
          component: ToastificationContent,
          props: {
            title: '獲取收據單據備註清單時出錯',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveIsActiveVariant = isActive => {
    if (isActive === 1) return 'success'
    if (isActive === 0) return 'secondary'
    return 'primary'
  }

  const resolveIsActiveText = isActive => {
    if (isActive === 1) return '啟用'
    if (isActive === 0) return '停用'
    return '未知'
  }

  return {
    fetchReceiptDocumentDescriptions,
    tableColumns,
    perPage,
    currentPage,
    totalReceiptDocumentDescriptions,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refReceiptDocumentDescriptionListTable,
    resolveIsActiveVariant,
    resolveIsActiveText,
    refetchData,
    ability,
    isActiveFilter,
    receiptDocumentDescriptionsList,
  }
}
